import React from 'react';
import Header from '../components/Header';
import TrendingVideos from '../components/TrendingVideos';

function Home() {
  return (
    <>
      <Header />
      <TrendingVideos />
    </>
  );
}

export default Home;
